import { ErrorTypes } from '../../../../shared/errors/ErrorEnums.ts';
import { ViewPopupLogin } from '../ui_popup/ui_popup_membership_incentive/ViewPopupLogin.ts';
import { showSimpleDialog } from '../ui_popup/showSimpleDialog.ts';
import { showTranslucentOverlay } from '../ui_overlays/showTranslucentOverlay.ts';
import { UIDeviceController } from '../ui_html/UIDeviceController.ts';
import { navigateToPage } from '../ui_utils/ClientUtils.ts';
import { uiManagerEvents } from '../EntryShared.ts';
import { isSubscriptionOverlayVariant } from '../store/subscription_overlay/subscriptionOverlayABTest.ts';
export class UIErrorHandler {
    static handleError(error) {
        switch(error.type){
            case ErrorTypes.DefaultError:
                this.showDefaultErrorPopup(error);
                break;
            case ErrorTypes.AuthError:
                this.showAuthErrorPopup(error);
                break;
            case ErrorTypes.MustLogin:
                new ViewPopupLogin();
                break;
            case ErrorTypes.MustBeMember:
                this.showMustBeMemberPopup(error);
                break;
            case ErrorTypes.Blocking:
                this.showBlockingPopup(error);
                break;
        }
    }
    static showDefaultErrorPopup(error) {
        const defaultError = {
            key: 'strings:popups.errors.general.title'
        };
        var _error_title;
        const title = (_error_title = error.title) !== null && _error_title !== void 0 ? _error_title : defaultError;
        showSimpleDialog({
            title: title,
            body: error.description
        });
    }
    static showAuthErrorPopup(error) {
        const defaultError = {
            key: 'strings:popups.errors.general.title'
        };
        var _error_title;
        const title = (_error_title = error.title) !== null && _error_title !== void 0 ? _error_title : defaultError;
        showSimpleDialog({
            title: title,
            body: error.getDisplayMessage()
        });
    }
    static showMustBeMemberPopup(error) {
        const defaultError = {
            key: 'strings:popups.errors.general.title'
        };
        var _error_title;
        const title = (_error_title = error.title) !== null && _error_title !== void 0 ? _error_title : defaultError;
        const url = UIDeviceController.isUserOnMobileAppOrWeb() ? '/mobile/store#membership' : '/store#membership';
        showSimpleDialog({
            title: title,
            body: error.description,
            confirmLabel: {
                key: 'strings:popups.uhOh.checkButton'
            },
            onConfirm: ()=>{
                if (isSubscriptionOverlayVariant()) uiManagerEvents.premiumMembershipCheckAction();
                else navigateToPage(url);
            }
        });
    }
    static showBlockingPopup(error) {
        const defaultError = {
            key: 'strings:popups.errors.general.title'
        };
        var _error_title;
        const title = (_error_title = error.title) !== null && _error_title !== void 0 ? _error_title : defaultError;
        showTranslucentOverlay({
            title: title,
            body: error.description
        });
    }
}
